// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__G79os","label":"styles_label__mgV5y","icon":"styles_icon__AsL_e"};